import {Component, Input, OnInit} from '@angular/core';
import {LittlesisLicensingService} from '../../../../services/littlesis-licensing.service';
import {LicenseState} from '../../../../services/licensing.interfaces';
import {LicensingTierTemplate} from '../../interface/licensingTier.interface';
import {MatDialogRef} from '@angular/material/dialog';
import {LicensingRenewalDialogComponent} from '../../licensing-renewal-dialog.component';
import {DatePipe} from '@angular/common';
import {BaseLicensingInfoComponent} from '../base-licensing-info/base-licensing-info.component';
import * as moment from 'moment';
import {AppUser, AuthService} from '../../../../../../core/modules/auth/services/auth.service';
import {LocalStorageService} from '../../../../../../core/localStorage/local-storage.service';
import {CustomerService} from '../../../../../../core/modules/auth/services/customer.service';

@Component({
  selector: 'app-lapsed-licensing-info',
  templateUrl: './lapsed-licensing-info.component.html',
  styleUrls: ['../../licensing-renewal-dialog.component.scss']
})
export class LapsedLicensingInfoComponent extends BaseLicensingInfoComponent  implements OnInit, LicensingTierTemplate {

  @Input() data: {
    licenseState: LicenseState;
    activeUser: AppUser;
    dialogRef: MatDialogRef<LicensingRenewalDialogComponent>;
  };



  constructor( public datePipe: DatePipe,
               public localStorageService: LocalStorageService,
               public authService: AuthService,
               private licenseService: LittlesisLicensingService,
               public customerService: CustomerService
               ) {
    super( datePipe, localStorageService, authService, customerService);
  }

  ngOnInit(): void {
    this.sourceData = this.data;
    super.ngOnInit();
    this.buildTemplateData(this.sourceData.licenseState);
  }

  buildTemplateData(licenseState: LicenseState): void{

    const expiryDisplayData = this.datePipe.transform(licenseState.license.subscriptions['ait-lsp'].expiry, 'MM/dd/yyyy');
    const pastDeleteDataWindow =  licenseState.expiresIn <= -90;
    const dataDeleteDate = this.datePipe.transform(moment(licenseState.license.subscriptions['ait-lsp'].expiry).endOf('d').add(90, 'd').toString(), 'MM/dd/yyyy');

    let expiryMessage;
    let showExpiredWarningIcon = false;
    if (licenseState.expiresIn > 0) {
      expiryMessage = `Your Lapsed license for ${licenseState.license.domain} expires on ${expiryDisplayData}.`;
    } else {
      expiryMessage = `Your Lapsed license for ${licenseState.license.domain} expired on ${expiryDisplayData}.`;
      showExpiredWarningIcon = true;
    }


    if(this.isSuperAdmin()){

      if(licenseState.expiresIn <= -90) {
        expiryMessage = `Your license for ${licenseState.license.domain} expired on ${expiryDisplayData} and ALL associated data for your domain was deleted on ${dataDeleteDate}.`;
      }

      this.templateData = {
        domain: licenseState.license.domain,
        expireDays: licenseState.expiresIn,
        expireDate: this.datePipe.transform(licenseState.license.subscriptions['ait-lsp'].expiry, 'MM/dd/yyyy'),
        expiryMessage,
        showIcon: showExpiredWarningIcon,
        showRecheckButton: !pastDeleteDataWindow,
        showRenewalButton: true,
        plan: 'lapsed',
        pastDeleteDataWindow,
        lastTierExpiration: {type: licenseState.lastTierExpiration.type, date: licenseState.lastTierExpiration.date}
      };
    } else {
      this.templateData = {
        domain: licenseState.license.domain,
        expireDays: licenseState.expiresIn,
        expireDate: this.datePipe.transform(licenseState.license.subscriptions['ait-lsp'].expiry, 'MM/dd/yyyy'),
        expiryMessage: `${expiryMessage} Please contact the Google Workspace Administrator for your domain for more information.`,
        lastTierExpiration: {type: licenseState.lastTierExpiration.type, date: licenseState.lastTierExpiration.date},
        showIcon: showExpiredWarningIcon,
        plan: 'lapsed'
      };
    }
  }



  recheckLicenseState(): void {
    this.licenseService.triggerForcedRecheck();
  }
}
